import { createSlice, Middleware } from "@reduxjs/toolkit"
import { creditDetails } from "./types"

type initialState = {
  response: creditDetails | null
}

export const customerDataSlice = createSlice({
  name: "customerData",
  initialState: { response: null } as initialState,
  reducers: {
    setCustomerData(state, action) {
      state.response = action.payload
    }
  }
})

export const { setCustomerData } = customerDataSlice.actions
export default customerDataSlice.reducer

export const customerDataHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
